import { setInteractionMode, extend } from 'vee-validate';
import { email, required, min, max, min_value, max_value } from '../external/vee-validate/dist/component-lib.esm.js';
import { messages } from '../external/vee-validate/dist/locale/component-lib.esm.js';
function setupValidation() {
  setInteractionMode('eager');

  // Add the rules you need.
  // extend('regex', { ...regex, message: messages['regex'] });
  extend('email', {
    ...email,
    message: messages['email']
  });
  extend('required', {
    ...required,
    message: messages['required']
  });
  extend('min', {
    ...min,
    message: messages['min']
  });
  extend('max', {
    ...max,
    message: messages['max']
  });
  extend('min_value', {
    ...min_value,
    message: messages['min_value']
  });
  extend('max_value', {
    ...max_value,
    message: messages['max_value']
  });
  // extend('length', { ...length, message: messages['length'] });
}

export { setupValidation };